"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const lodash_1 = require("lodash");
const atoms_1 = require("../../atoms");
function GroupMembersUserItem({ index, group, membership, onRemove = lodash_1.noop, }) {
    const isAdmin = membership.isAdmin;
    const isOwner = membership.isFounder;
    const isInvitePending = membership.status === bridge_schema_1.MembershipStatus.Invited;
    const isNotMember = !(membership.status === bridge_schema_1.MembershipStatus.Member) && !isInvitePending;
    const isOrdinaryMember = !isAdmin && membership.status === bridge_schema_1.MembershipStatus.Member;
    const invite = ((0, jsx_runtime_1.jsx)(atoms_1.InviteButton, { groupId: group.identifier, userId: membership.userIdentifier, label: membership.name, "data-e2e": 'GroupMembersUserItem_InviteButton' }));
    const makeAdmin = ((0, jsx_runtime_1.jsx)(atoms_1.MakeAdminButton, { groupId: group.identifier, userId: membership.userIdentifier, "data-e2e": 'GroupMembersUserItem_MakeAdminButton' }));
    const rejectAdmin = ((0, jsx_runtime_1.jsx)(atoms_1.RejectAdminButton, { membershipId: membership.identifier, "data-e2e": 'GroupMembersUserItem_RejectAdminButton' }));
    const onRemoveMember = () => {
        onRemove(membership);
    };
    const renderButtons = () => {
        if (isOwner) {
            return ((0, jsx_runtime_1.jsx)(OwnerLabel, { "data-e2e": 'GroupMembersUserItem_OwnerLabel', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.members.owner) }));
        }
        if (isAdmin && !group.isFounder) {
            return ((0, jsx_runtime_1.jsx)(OwnerLabel, { "data-e2e": 'GroupMembersUserItem_OwnerLabel', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.members.groupAdmin) }));
        }
        return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [isNotMember && invite, isAdmin && rejectAdmin, group.isFounder && isOrdinaryMember && makeAdmin, (0, jsx_runtime_1.jsx)(atoms_1.RemoveUserButton, { membershipId: membership.identifier, onRemove: onRemoveMember, "data-e2e": 'GroupMembersUserItem_RemoveUserButton' })] }));
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'GroupMembersUserItem_Container', children: [(0, jsx_runtime_1.jsx)(Index, { "data-e2e": 'GroupMembersUserItem_Index', children: index }), (0, jsx_runtime_1.jsx)(UserAvatar, { image: membership.avatar, "data-e2e": 'GroupMembersUserItem_UserAvatar' }), (0, jsx_runtime_1.jsx)(atoms_1.MemberLabel, { name: membership.name, isInvitePending: isInvitePending, "data-e2e": 'GroupMembersUserItem_MemberLabel' }), (0, jsx_runtime_1.jsx)(ButtonsContainer, { "data-e2e": 'GroupMembersUserItem_ButtonsContainer', children: renderButtons() })] }, index));
}
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;

  flex-shrink: 0;

  width: 100%;
  height: 60px;
`;
const Index = styled_components_1.default.div `
  position: absolute;
  top: 22px;
  left: -10px;

  color: ${props => props.theme.text};

  font-size: 12px;
`;
const UserAvatar = (0, styled_components_1.default)(ui_1.Avatar) `
  width: 40px;
  height: 40px;

  margin: auto 10px auto 15px;

  color: ${props => props.theme.sharing.avatar.fill};

  background-color: ${props => props.theme.sharing.avatar.background};
`;
const ButtonsContainer = styled_components_1.default.div `
  display: flex;

  margin: auto 0;
`;
const OwnerLabel = styled_components_1.default.div `
  margin: auto 0 auto 20px;

  color: ${props => props.theme.text};

  font-size: 12px;
`;
exports.default = GroupMembersUserItem;
